import type Base from "./Base";
import TinTie from "./TinTie";
import Valve from "./Valve";

export default class Addons {
	private addons: Array<Base> = [];
	private readonly availableAddons = [Valve, TinTie];
	/** @param onChange */
	constructor(protected onChange: () => void) {
		for (const addon of this.availableAddons) {
			if (document.querySelector(addon.optionSelector)) {
				this.addons.push(
					new addon(() => {
						onChange();
					}),
				);
			}
		}
	}

	public getAddons(): Array<Base> {
		return this.addons;
	}
}
